import { render, staticRenderFns } from "./SensorAssignmentCookingName.vue?vue&type=template&id=2e53c68b&"
import script from "./SensorAssignmentCookingName.vue?vue&type=script&lang=js&"
export * from "./SensorAssignmentCookingName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports